"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasProperty = void 0;
var get_1 = __importDefault(require("lodash/get"));
/**
 * @category Front End Only
 *
 * @param object Object to check if property exists
 * @param path a '.' separated path string, or array of subpaths
 * @returns whether the data is defined on the object (even if null, it counts as defined)
 *
 * @example
 * hasProperty({ a: null }, 'a') // true
 * @example
 * hasProperty({}, 'a') // false
 */
function hasProperty(object, path) {
    return typeof (0, get_1.default)(object, path) !== 'undefined';
}
exports.hasProperty = hasProperty;
//# sourceMappingURL=object.js.map